import { UserRole } from '@sharefiledev/sharing-pilet-sdk';

export interface Mode {
	read?: boolean;
	write?: boolean;
}

export interface Permission {
	read?: boolean;
	write?: boolean;
}

export type UserDetails = {
	userType: string;
	Role?: string;
	FirstName: string;
	LastName: string;
	Email: string;
	Id: string;
};

export type UserDetailsResponse = {
	users: Record<string, UserDetails>;
};

export enum SortDirection {
	Asc = 'asc',
	Desc = 'desc',
}

export enum FormState {
	CLOSE = 'close',
	UPDATE = 'update',
	CREATE = 'create',
}

export interface SortParams {
	sortKey?: string;
	direction?: SortDirection;
}

export interface SearchParams {
	searchTerm?: string;
}
export type ColorPalette = {
	value: string;
	background: string;
	color: string;
};

export type Colors = {
	[key in string]: {
		value: string;
		background: string;
		color: string;
		accentColor: string;
	};
};

export type Filters = {
	[key in string]: (string | number)[] | [];
};

export type RecordQueryParam = {
	sort?: string;
	filter?: string;
	search?: string;
	contacts?: string;
	placeholder?: string;
	limit?: number;
	skip?: number;
};

export type TasksQueryParam = {
	containerRID: string;
	enableTapViewForSP?: boolean;
	kind?: 'actionable' | 'nonActionable';
	take?: number;
};

export type RecordQueryParams = {
	[key in string]: RecordQueryParam;
};

export const DataTablePiletEvents = {
	deleted: 'urn:event:resource:deleted',
	updated: 'urn:event:resource:updated',
};

export enum DataTableEntityType {
	datatable = 'datatable',
}

export interface ReloadTableResponse {
	tableSchema: any;
	recordsResponse: any;
}

export type ExportTablePayload = {
	resourceId: string;
	filter: Filters;
	fileType: 'csv';
	fileName: string;
	requestId: string;
};

export type ExportContext = {
	_id: string;
	resourceId: string;
	fileName: string;
	filter: object;
	fileType: string;
	requestId: string;
};

export type ExportStatusQueryParams = {
	resourceId?: string;
	requestId?: string;
};

export type EventMetadata = {
	originAnalyticsTrackingId?: string;
	subType?: string;
	userType?: UserRole;
	timeStamp?: string;
	schemaLabel?: string;
	calledFromWidget?: boolean; // Added new metadata field
	origin?: string;
	schemaName?: string;
};
